module.exports = __webpack_public_path__ + "assets/img/立即开通@2x(1).06e9737a.png";